import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { memberClosetSliceInitialState, MemberClosetState } from './memberClosetSliceInitialState';
import { MemberCloset } from 'types/member/memberCloset';
import { AxiosError } from 'axios';
import { Nullable } from 'types/common';

export const memberClosetSlice = createSlice({
  name: 'memberCloset',
  initialState: memberClosetSliceInitialState,
  reducers: {
    getMemberCloset: (state: MemberClosetState, _action: PayloadAction<{ userId: string }>) => {
      state.loading = true;
    },
    getMemberClosetSuccess: (state: MemberClosetState, action: PayloadAction<MemberCloset>) => {
      state.loading = false;
      state.memberCloset = action.payload;
    },
    getMemberClosetFailure: (
      state: MemberClosetState,
      action: PayloadAction<Nullable<AxiosError>>,
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const memberClosetActions = memberClosetSlice.actions;
export const memberClosetReducer = memberClosetSlice.reducer;
